import { Component, inject } from '@angular/core'
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog'
import { MatSelectChange, MatSelect } from '@angular/material/select'
import { CarrierData } from '../../../api/model/backend.model'
import { AccountMappingData } from '../../model/program-initiation.model'
import { environment as ENV } from '../../../../environments/environment'
import { CdkScrollable } from '@angular/cdk/scrolling'
import { MatFormField, MatLabel } from '@angular/material/form-field'

import { MatOption } from '@angular/material/autocomplete'
import { ButtonComponent } from '../../../shared/button/button.component'

@Component({
  selector: 'app-program-initiation-mapping-action-dialog',
  templateUrl: './program-initiation-mapping-action-dialog.component.html',
  styleUrls: ['./program-initiation-mapping-action-dialog.component.scss'],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatDialogActions,
    ButtonComponent,
    MatDialogClose,
  ],
})
export class ProgramInitiationMappingActionDialogComponent {
  dialogRef = inject<MatDialogRef<ProgramInitiationMappingActionDialogComponent>>(MatDialogRef)
  data = inject<{
    carriers: CarrierData[]
    accountMappingData: AccountMappingData
  }>(MAT_DIALOG_DATA)

  carriers: CarrierData[]
  private selectedCarrier: CarrierData
  constructor() {
    const blacklist = ENV.carrierIdMappingBlacklist
    this.carriers = this.data.carriers
      .filter((carrier) => !blacklist.has(carrier.id))
      .sort((a, b) => a.name.localeCompare(b.name))
  }

  updateCarrier() {
    const updatedMapping: AccountMappingData = {
      sfAccountId: this.data.accountMappingData.sfAccountId,
      sfAccountName: this.data.accountMappingData.sfAccountName,
      carrierId: this.selectedCarrier.id,
      carrierName: this.selectedCarrier.name,
    }
    this.dialogRef.close(updatedMapping)
  }

  onCarrierSelectionChange(change: MatSelectChange): void {
    this.selectedCarrier = change.value
  }
}
